module.exports = __webpack_public_path__ + "static/media/es.f1b1f559.svg";